import Layout from "@/ux/layout/Layout.vue";
import HomeView from "../ux/home/HomeView.vue";
import SocialNetworksView from "../ux/socialNetworks/SocialNetworksView.vue";
import OtherServicesView from "../ux/otherServices/OtherServicesView.vue";
import CorporateView from "../ux/corporate/CorporateView.vue";
import ProductView from "../ux/product/ProductView.vue";
import PublicityGalleryView from "../ux/product/PublicityGalleryView.vue";
import EcommerceGalleryView from "../ux/product/EcommerceGalleryView.vue";
import FashionView from "../ux/fashion/FashionView.vue";
import EditorialGalleryView from "../ux/fashion/EditorialGalleryView.vue";
import FashionEcommerceGalleryView from "../ux/fashion/FashionEcommerceGalleryView.vue";
import Error404View from "../ux/pageNotFound/Error404View.vue";

export const websiteRoutes = [
  {
    path: "/",
    redirect: "/home",
    component: Layout,
    children: [
      {
        path: "/home",
        name: "home",
        component: HomeView,
      },
      {
        path: "/social-networks",
        name: "social-networks",
        component: SocialNetworksView,
      },
      {
        path: "/other-services",
        name: "other-services",
        component: OtherServicesView,
      },
      {
        path: "/corporate",
        name: "corporate",
        component: CorporateView,
      },
      {
        path: "/product",
        name: "product",
        component: ProductView,
      },
      {
        path: "/publicity-gallery",
        name: "publicity-gallery",
        component: PublicityGalleryView,
      },
      {
        path: "/ecommerce-gallery",
        name: "ecommerce-gallery",
        component: EcommerceGalleryView,
      },
      {
        path: "/fashion",
        name: "fashion",
        component: FashionView,
      },
      {
        path: "/editorial-gallery",
        name: "editorial-gallery",
        component: EditorialGalleryView,
      },
      {
        path: "/fashion-ecommerce-gallery",
        name: "fashion-ecommerce-gallery",
        component: FashionEcommerceGalleryView,
      },
      {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: Error404View,
      },
    ],
  },
];
